import { useQuery } from "@tanstack/react-query";
import { querykeys } from "../querykeys";
import { endpoints } from "../endpoints";
import { getResource } from "../https";
import { CartItem } from "../types";

interface CartCount {
  data: {
    count: number
  };
}

interface CartResponse {
  data: {
    items: CartItem[];
    summary: {
      totalItems: number;
      subtotal: string;
      currency: string;
    };
  };
}


export const getCartCount = async (): Promise<CartCount> => {
  return await getResource({
    pathUrl: `${endpoints.cartCount}`,
  });
};

export const getCartItems = async (): Promise<CartResponse> => {
  return await getResource({
    pathUrl: `${endpoints.cart}`,
  });
};

export const useGetCartItems = () => {
  const query = useQuery({
    queryKey: [querykeys.GET_CART_ITEMS],
    queryFn: () => getCartItems(),
  });
  return query;
};

export const useGetCartCount = () => {
  const query = useQuery({
    queryKey: [querykeys.GET_CART_COUNT],
    queryFn: () => getCartCount(),
  });
  return query;
};
